document.addEventListener('DOMContentLoaded', function() {
  const prescriptionMethod = document.getElementById('prescription-method');
  
  // Add to cart validation
  const addToCartButton = document.querySelector('[name="add"]');
  if (addToCartButton && prescriptionMethod) {
    addToCartButton.addEventListener('click', function(e) {
      const prescriptionOptionsDiv = document.querySelector('.prescription-options');
      if (prescriptionOptionsDiv && prescriptionMethod.value === '') {
        e.preventDefault();
        alert('Please select how you will provide your prescription.');
        prescriptionMethod.focus();
      }
    });
  }
});